/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ProjectSummary,
  ProjectSummary$inboundSchema,
} from "./projectsummary.js";

/**
 * Result of metrics summary query
 */
export type GetMetricsSummaryResult = {
  /**
   * Aggregated metrics
   */
  metrics: ProjectSummary;
};

/** @internal */
export const GetMetricsSummaryResult$inboundSchema: z.ZodMiniType<
  GetMetricsSummaryResult,
  unknown
> = z.object({
  metrics: ProjectSummary$inboundSchema,
});

export function getMetricsSummaryResultFromJSON(
  jsonString: string,
): SafeParseResult<GetMetricsSummaryResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMetricsSummaryResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMetricsSummaryResult' from JSON`,
  );
}
